import { render, staticRenderFns } from "./newsletter-activate.vue?vue&type=template&id=5bd5c98b&scoped=true"
import script from "./newsletter-activate.vue?vue&type=script&lang=ts"
export * from "./newsletter-activate.vue?vue&type=script&lang=ts"
import style0 from "./newsletter-activate.vue?vue&type=style&index=0&id=5bd5c98b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5c98b",
  null
  
)

export default component.exports